import { Component, NgZone } from '@angular/core';
import { AgRendererComponent } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AppState } from '../../app.state';
import { Store } from '@ngrx/store';
import { selectTankGridChange } from 'src/app/state/selectors/tank-profile.selectors';
import { take } from 'rxjs/operators';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'tank-notification-renderer',
  templateUrl: "./tank-notification-renderer.component.html",
  styleUrls: ["./tank-notification-renderer.component.css"],
})


export class TankNotificationRendererComponent implements AgRendererComponent {
  public tankNotifications: [];
  public id: number = 0;
  public tankNotificationCount: number = 0;
  private tankSubscription;

  constructor(
    private logger: LogService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ngZone: NgZone,
    private store: Store<AppState>
  ) { }

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.parseData(params);
  }

  parseData(params: ICellRendererParams): void {
    this.id = params.data.tankID;
    this.tankNotifications = params.data.tankNotifications;
    this.tankNotificationCount = params.value;
  }

  // gets called whenever the user gets the cell to refresh
  refresh(params: ICellRendererParams) {
    // set value into cell again
    this.parseData(params);
    return true;
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  }

  showTankNotifications(id: number) {
    this.logger.trackEvent("TankGrid", "click", "TankNotifications", id);
    this.ngZone.run(() => this.router.navigate(['./notifications', id]));

  //  // pull grid request data from state store
  //  this.tankSubscription = this.store.select(selectTankGridChange).pipe(take(1)).subscribe(tankGridRequest => {

  //    // send grid request data to tank notification page
  //    this.logger.trackEvent("TankGrid", "click", "NavigateToTankNotifications");
  //    this.ngZone.run(() => this.router.navigate(['./notifications', id], { state: { ...window.history.state, tankNotificationRequest: tankGridRequest } })).then();
  //  });
  }
}
